const actions = {
  ADD_ITEM: 'breadcrumb/ADD_ITEM',
  SET_STATE: 'breadcrumb/SET_STATE',
  GET_STATE: 'breadcrumb/GET_STATE',
}

export const addItem = (key: string, value: string) => {
  return {
    type: actions.ADD_ITEM,
    payload: {
      key,
      value,
    },
  }
}

export default actions
